/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import * as XLSX from "xlsx";
import axios from 'axios';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import axiosInstance from '../axiosInstance';

function AddReceipt() {
    const navigate = useNavigate();
    const location = useLocation();

    const [existingData, setexistingData] = useState(null);
    const [editData, seteditData] = useState(null);
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    const [newRecord, setNewRecord] = useState({
        id: "",
        reg_no: "",
        recipient_name: "",
        recipient_city: "",
        finance_date: "",
        next_due_date: "",
        loan_amount: "",
        paid_loanamount: "",
        balance_loanamount: "",
        totaldue_count: "",
        paiddue_count: "",
        balancedue_count: "",
        noofdue: "",
        principal: "",
        interest: "",
        due_day: "",
        due_no: "",
        emi_amount: "",
        previous_due_balance: "",
        penalty_perday: "",
        penalty: "",
        penalty_paid: "",
        penalty_balance: "",
        late_fine: "",
        late_fine_paid: "",
        late_fine_balance: "",
        due_amount: "",
        due_amount_paid: "",
        due_amount_balance: "",
        total: "",
        payment_type: "",
        remark: "",
    });

    const [errors, setErrors] = useState({
        noofdue: "",
        principal: "",
        interest: "",
        due_amount: "",
        total: "",
        payment_type: ""
    });
    const [registrations, setRegistrations] = useState([]);

    useEffect(() => {
        const existingData = location.state || null;
        setexistingData(existingData);

    }, [location.state]);

    useEffect(() => {
        if (existingData) {
            const financeId = existingData.id;

            const fetchPreviousDetails = async () => {
                try {
                    const response = await axiosInstance.get(`/receipt/previousdetails/${financeId}`);
                    console.log("freshapidata: ", response.data)
                    const fineBalance = Number(existingData.fine_balance);
                    const calculatedFine = Number(response.data.calculated_fine);
                    const newValues = {
                        id: existingData.id,
                        reg_no: existingData.reg_no,
                        recipient_name: existingData.borrower_name,
                        recipient_city: existingData.borrower_city,
                        finance_date: existingData.date,
                        next_due_date: response.data.due_date,
                        loan_amount: existingData.loan_amount,
                        paid_loanamount: response.data.totalpaiddue,
                        balance_loanamount: response.data.totalbalancedue,
                        totaldue_count: response.data.totalduecount,
                        paiddue_count: response.data.due_receipt_count,
                        balancedue_count: response.data.balanceduecount,
                        principal: existingData.principal_amount,
                        interest: existingData.interest_amount,
                        due_day: existingData.due_date,
                        due_no: response.data.due_no,
                        emi_amount: existingData.emi_amount,
                        previous_due_balance: existingData.due_balance,
                        penalty_perday: existingData.penalty_perday,
                        penalty: response.data.penalty,
                        late_fine: existingData.fine_balance,
                        late_fine_paid: (fineBalance > 0)
                            ? fineBalance
                            : (calculatedFine > 0 ? calculatedFine : 0),
                    };

                    // Compute total from latest fetched values
                    const total =
                        (parseFloat(newValues.previous_due_balance) || 0) +
                        (parseFloat(newValues.due_amount) || 0) +
                        (parseFloat(newValues.penalty) || 0) +
                        (parseFloat(newValues.late_fine) || 0);

                    setNewRecord({
                        ...newValues,
                        total: total
                    });

                } catch (error) {
                    console.error('Error fetching previous data:', error);
                }
            };

            fetchPreviousDetails();
        }
    }, [existingData]);


    useEffect(() => {
        const fetchRegistrationData = async () => {
            try {
                const endpoint = existingData
                    ? '/dealer/listforbilling'
                    : '/dealer/listforfinance';
                console.log("endpoint:", endpoint)
                const response = await axiosInstance.get(endpoint);
                setRegistrations(response.data);

            } catch (error) {
                console.error('Error fetching registration data:', error);
                setRegistrations([]);
            }
        };

        fetchRegistrationData();
    }, [existingData]);


    const formatToMysqlDate = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`; // "2025-07-24"
    };

    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.noofdue) {
            formErrors.noofdue = "No of Due is required";
        }

        if (!newRecord.due_amount) {
            formErrors.dueAmount = "Due Amount is required";
        }

        if (!newRecord.total) {
            formErrors.total = "Total Amount is required";
        }

        if (!newRecord.payment_type) {
            formErrors.payment_type = "Payment Type is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    const calculateReceipts = () => {
        const no_of_dues = newRecord.noofdue;
        let total = newRecord.total;
        const emi_amount = newRecord.emi_amount;
        let remainingDueBal = newRecord.previous_due_balance;
        let remainingPenalty = newRecord.penalty;
        let userProvidedFine = newRecord.late_fine_paid;
        const due_day = parseInt(newRecord.due_day) || 1;
        const due_no = parseInt(newRecord.due_no) || 0;
        const finance_date = newRecord.finance_date;
        const next_date = newRecord.next_due_date;
        const penalty_perday = newRecord.penalty_perday;
        const today = new Date();
        const penalty = newRecord.penalty;
        const existingFineBalance = parseFloat(newRecord.late_fine) || 0;

        const receiptsList = [];

        // Step 1: Handle priority payments first
        let totalDueBalPaid = 0;
        let totalPenaltyPaid = 0;
        let totalFinePaid = 0;

        if (remainingDueBal > 0 && total > 0) {
            const used = Math.min(remainingDueBal, total);
            total -= used;
            totalDueBalPaid = used;
            remainingDueBal -= used;
        }

        if (remainingPenalty > 0 && total > 0) {
            const used = Math.min(remainingPenalty, total);
            total -= used;
            totalPenaltyPaid = used;
            remainingPenalty -= used;
        }

        if (userProvidedFine > 0 && total > 0) {
            const used = Math.min(userProvidedFine, total);
            total -= used;
            totalFinePaid = used;
        }

        // Helper function to add months correctly
        const addMonthsToDate = (date, months) => {
            const result = new Date(date);
            const originalDay = result.getDate();

            // Add the months
            result.setMonth(result.getMonth() + months);

            // Check if the day rolled over (e.g., Jan 31 -> Mar 3 instead of Feb 28)
            if (result.getDate() !== originalDay) {
                // Set to the last day of the intended month
                result.setDate(0);
            }

            return result;
        };

        // Helper function to format date as dd-MM-yyyy
        const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        // Step 2: Calculate dues
        let cumulativeFineBalance = existingFineBalance;
        let finePaidSoFar = 0;
        let dueIndex = 0;
        let currentDueDate = null;

        // FIX: Initialize the first due date BEFORE the loop
        if (next_date && next_date.trim() !== '') {
            currentDueDate = new Date(next_date);
        } else {
            // Fallback: finance_date + 1 month, set to due_day
            const baseDate = new Date(finance_date);
            currentDueDate = addMonthsToDate(baseDate, 1);
            currentDueDate.setDate(due_day);

            // Validate the day
            if (currentDueDate.getDate() !== due_day) {
                // If invalid day for month (e.g., Feb 31), use last day of month
                currentDueDate.setMonth(currentDueDate.getMonth() + 1, 0);
            }
        }

        console.log("Starting with due date:", formatDate(currentDueDate));

        while (total > 0 || dueIndex < no_of_dues) {
            // FIX: Calculate next_due_date FIRST (before using currentDueDate)
            const next_due_date = addMonthsToDate(currentDueDate, 1);

            // Calculate fine days based on current due date
            const currentDueDateTime = new Date(currentDueDate);
            currentDueDateTime.setHours(0, 0, 0, 0);

            const todayDateTime = new Date(today);
            todayDateTime.setHours(0, 0, 0, 0);

            const def_days = Math.max(Math.floor((todayDateTime - currentDueDateTime) / (1000 * 60 * 60 * 24)), 0);
            const total_fine_due = def_days * penalty_perday;

            // Add current row fine to cumulative balance
            cumulativeFineBalance += total_fine_due;

            // Pay current EMI due
            let dueReceived = 0;
            let dueBalance = emi_amount;

            if (total > 0) {
                const used = Math.min(emi_amount, total);
                total -= used;
                dueReceived = used;
                dueBalance = emi_amount - used;
            }

            // Allocate priority payments
            let allocatedDueBal = 0;
            let allocatedPenalty = 0;
            let allocatedFine = 0;

            if (totalDueBalPaid > 0) {
                const share = Math.min(totalDueBalPaid, dueBalance);
                allocatedDueBal = share;
                totalDueBalPaid -= share;
            }

            if (totalPenaltyPaid > 0 && dueIndex === 0) {
                allocatedPenalty = totalPenaltyPaid;
                totalPenaltyPaid = 0;
            }

            if (totalFinePaid > 0) {
                const availableFineToAllocate = Math.min(totalFinePaid, cumulativeFineBalance - finePaidSoFar);
                allocatedFine = Math.max(0, availableFineToAllocate);
                totalFinePaid -= allocatedFine;
            }

            finePaidSoFar += allocatedFine;
            const currentBalanceFine = cumulativeFineBalance - finePaidSoFar;

            receiptsList.push({
                due: due_no + dueIndex + 1,
                due_date: formatDate(currentDueDate),
                rcpt_date: formatDate(today),
                due_amt: emi_amount,
                due_rcvd: dueReceived,
                due_bal: dueBalance,
                due_balancepaid: allocatedDueBal,
                def_days: def_days,
                fine: total_fine_due,
                payedFine: allocatedFine,
                balance_fine: currentBalanceFine,
                penalty: dueIndex === 0 ? penalty : 0,
                payedPenalty: allocatedPenalty,
                penalty_bal: dueIndex === 0 ? remainingPenalty : 0,
                remaining_total: total,
                next_due_date: formatDate(next_due_date)
            });

            console.log(`Iteration ${dueIndex}: currentDueDate = ${formatDate(currentDueDate)}, next_due_date = ${formatDate(next_due_date)}`);

            dueIndex++;

            // FIX: Move to next due date for the next iteration
            currentDueDate = new Date(next_due_date);

            console.log(`After update: New currentDueDate for next iteration = ${formatDate(currentDueDate)}`);

            // Break conditions
            if ((total <= 0 && dueIndex >= no_of_dues) || dueIndex >= 100) {
                break;
            }
        }

        setReceipts(receiptsList);
        console.log("Calculated receipts:", receiptsList);
        console.log("Final remaining total:", total);

        return receiptsList;
    };
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setErrors({});
            try {
                setLoading(true);

                // Calculate receipts and get the result immediately
                const calculatedReceipts = calculateReceipts();
                const createdBy = localStorage.getItem('user_id')
                // Prepare data for API using the fresh calculated receipts
                const receiptData = {
                    finance_id: newRecord.id,
                    reg_no: newRecord.reg_no,
                    recipient_name: newRecord.recipient_name,
                    recipient_city: newRecord.recipient_city,
                    noofdue: newRecord.noofdue,
                    principal: newRecord.principal || 0,
                    interest: newRecord.interest || 0,
                    penalty: newRecord.penalty,
                    penalty_paid: calculatedReceipts.reduce((sum, r) => sum + (r.payedPenalty || 0), 0),
                    penalty_balance: calculatedReceipts.reduce((sum, r) => sum + (r.penalty_bal || 0), 0),
                    late_fine: calculatedReceipts.reduce((sum, r) => sum + (r.fine || 0), 0),
                    late_fine_paid: calculatedReceipts.reduce((sum, r) => sum + (r.payedFine || 0), 0),
                    //late_fine_balance: calculatedReceipts[calculatedReceipts.length - 1]?.balance_fine || 0,
                    late_fine_balance: Math.max(0, calculatedReceipts.reduce((maxBalance, r) => Math.max(maxBalance, r.balance_fine || 0), 0)),
                    previous_due_balance: newRecord.previous_due_balance,
                    due_amount: calculatedReceipts.reduce((sum, r) => sum + (r.due_amt || 0), 0),
                    due_amount_paid: calculatedReceipts.reduce((sum, r) => sum + (r.due_rcvd || 0), 0),
                    due_amount_balance: calculatedReceipts.reduce((sum, r) => sum + (r.due_bal || 0), 0),
                    total: newRecord.total,
                    payment_type: newRecord.payment_type,
                    remark: newRecord.remark,
                    created_by: createdBy,
                    due_receipts: calculatedReceipts.map((receipt, index) => ({
                        due_no: receipt.due,
                        due_date: formatToMysqlDate(receipt.due_date), // Already formatted as dd-MM-yyyy
                        due_amt: receipt.due_amt,
                        due_rcvd: receipt.due_rcvd,
                        due_bal: receipt.due_bal,
                        fine_days: receipt.def_days,
                        penalty: receipt.penalty,
                        fine: receipt.fine,
                        payed_fine: receipt.payedFine,
                        balance_fine: receipt.balance_fine,
                        next_due_date: formatToMysqlDate(receipt.next_due_date), // Already formatted as dd-MM-yyyy
                        created_by: createdBy
                    }))
                };

                console.log("Receipt data:", receiptData);
                console.log("Due receipts:", receiptData.due_receipts);
                console.log("Due receipts Due NO:", receiptData.due_receipts.due_no);

                let response;
                response = await axiosInstance.post('/receipt/add', receiptData);

                if (response.data.success) {
                    await Swal.fire('Created!', 'The Receipt record has been Created.', 'success');
                    setNewRecord({
                        id: "",
                        reg_no: "",
                        recipient_name: "",
                        recipient_city: "",
                        finance_date: "",
                        next_due_date: "",
                        loan_amount: "",
                        paid_loanamount: "",
                        balance_loanamount: "",
                        totaldue_count: "",
                        paiddue_count: "",
                        balancedue_count: "",
                        noofdue: "",
                        principal: "",
                        interest: "",
                        due_day: "",
                        due_no: "",
                        emi_amount: "",
                        previous_due_balance: "",
                        penalty_perday: "",
                        penalty: "",
                        penalty_paid: "",
                        penalty_balance: "",
                        late_fine: "",
                        late_fine_paid: "",
                        late_fine_balance: "",
                        due_amount: "",
                        due_amount_paid: "",
                        due_amount_balance: "",
                        total: "",
                        payment_type: "",
                        remark: "",
                    });
                    navigate('/finance');

                } else {
                    throw new Error(response.data.message);
                }

            } catch (error) {
                console.error('Error saving receipt:', error);
                const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
                Swal.fire('Error!', `There was an issue creating the Receipt record: ${errorMessage}`, 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let updatedRecord = {
            ...newRecord,
            [name]: value
        };

        if (name === 'noofdue') {
            const dueCount = parseInt(value, 10) || 0;
            updatedRecord.due_amount = dueCount * (parseFloat(newRecord.emi_amount) || 0);
        }

        // Recalculate total when relevant fields change
        const recalcFields = ['noofdue', 'penalty', 'late_fine_paid'];
        if (recalcFields.includes(name)) {
            const previous_due_balance = parseFloat(updatedRecord.previous_due_balance) || 0;
            const dueAmount = parseFloat(updatedRecord.due_amount) || 0;
            const penalty = parseFloat(updatedRecord.penalty) || 0;
            const lateFine = parseFloat(updatedRecord.late_fine_paid) || 0;

            updatedRecord.total = previous_due_balance + dueAmount + penalty + lateFine;
        }

        if (name === 'total') {
            updatedRecord.total = parseFloat(value) || 0;
        }

        setNewRecord(updatedRecord);
    };





    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Receipt</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/finance">Finance</a></li>
                                <li className="breadcrumb-item active">Receipt</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2 mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            {newRecord && (
                                <>
                                    <div className="delivery-note-info">
                                        <div>
                                            <h3 className="delivery-note-fromto">Recipient Details:</h3>
                                            <p><strong>Registration No: </strong>{newRecord.reg_no || ""}</p>
                                            <p><strong>Recipient Name: </strong>{newRecord.recipient_name || ""}</p>
                                            <p><strong>Recipient City: </strong>{newRecord.recipient_city || ""}</p>
                                            <p><strong>Finance Date: </strong>{new Date(newRecord.finance_date).toLocaleDateString("en-GB") || ""}</p>
                                        </div>
                                        <div>
                                            <h3 className="delivery-note-fromto">Finance Details:</h3>
                                            <p><strong>Loan Amount: </strong>{newRecord.loan_amount}</p>
                                            <p><strong>Loan Amount Paid: </strong>{newRecord.paid_loanamount}</p>
                                            <p><strong>Loan Amount Balance: </strong>{newRecord.balance_loanamount}</p>
                                            <p><strong>EMI Amount: </strong>{newRecord.emi_amount}</p>
                                            <p><strong>Total Dues: </strong>{newRecord.totaldue_count}</p>
                                            <p><strong>Paid Dues: </strong>{newRecord.paiddue_count}</p>
                                            <p><strong>Balance Due: </strong>{newRecord.balancedue_count}</p>
                                        </div>
                                    </div>

                                    <hr class="divider"></hr>

                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Due</label>
                                                    <input type="text" name="noofdue" value={newRecord.noofdue} onChange={handleInputChange} className="form-control" />
                                                    {errors.noofdue && <small className="text-danger">{errors.noofdue}</small>}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Due Amount</label>
                                                    <input type="text" name="due_amount" value={newRecord.due_amount} onChange={handleInputChange} className="form-control" readOnly />
                                                    {errors.due_amount && <small className="text-danger">{errors.due_amount}</small>}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Due Balance</label>
                                                    <input type="text" name="previous_due_balance" value={newRecord.previous_due_balance} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Penalty</label>
                                                    <input type="text" name="penalty" value={newRecord.penalty} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Late Fine</label>
                                                    <input type="text" name="late_fine_paid" value={newRecord.late_fine_paid} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div class="form-group">
                                                    <label for="payment_type1">Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%" }} name="payment_type" value={newRecord.payment_type} onChange={handleInputChange} >
                                                        <option value="">Select Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Card">Card</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                    {errors.payment_type && <small className="text-danger">{errors.payment_type}</small>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Remark</label>
                                                    <input type="text" name="remark" value={newRecord.remark} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Total Amount</label>
                                                    <input type="text" name="total" value={newRecord.total} onChange={handleInputChange} className="form-control" />
                                                    {errors.total && <small className="text-danger">{errors.total}</small>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="modal-footer justify-content-between">
                                            <button type="submit" className="btn btn-primary">Save Receipt</button>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddReceipt